<template>
  <div>
    <base-date-picker
      appendIcon="mdi-calendar-month"
      label="出生日期"
      ref="datePicker"
    ></base-date-picker>
  </div>
</template>
<script>
import BaseDatePicker from "../common/BaseDatePicker";

export default {
  components: {
    BaseDatePicker
  },
  data: () => ({
    async getReport() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/reports/${this.petIdNow}/0`
      );

      this.reports = response.data;
      this.step = 3;
      await this.$nextTick();

      this.$refs.listReport.setReports(
        this.petIdNow,
        this.petNow,
        response.data
      );
    }
  }),
  mounted() {
    this.$refs.datePicker.setDate("2020-9-6");
  }
};
</script>
